import React, { useState,useEffect } from 'react';
import { Link, Route,Routes} from 'react-router-dom';
import BottomTab from './BottomTab';
import axios from 'axios';
import Api from "../Api/Api.json";
import BPPlugin from '../BPPlugin';

const items = ['BP', 'Stetho', 'Glucose'];
var user_id='0';
const BP = () => {
    const [newFlag,setNewFlag]=useState(false);
    const [bpList,setBPList]=useState([]);    
    const [bpstatus,setBPStatus]=useState("Click connect device");
    var external_id=0;

    useEffect(()=>{
      if (localStorage.getItem('user_info')!==null){
        //navigate('/Landing/tab1')
        var user_info=JSON.parse(localStorage.getItem('user_info'));
        external_id=user_info.phone;
        user_id=user_info.di_id.toString();        
        console.log("userid");
        console.log(user_id);
      }
      const headers = { headers: { "Content-Type": "application/json" } }
      const url = Api.FITNESS_API;
      const requestData = {
        task: 'getUserBP',
        external_id: external_id
      };
      axios.post(url,requestData,headers)
      .then(response=>{
        if (response.data.length > 0){
          const arr=[];
      //onLogin(username);
      //console.log(response.data)
      
      response.data.forEach(
          obj=>{
            //console.log(obj)
            //const arr=[...prescription_list];
            arr.push(obj['measurement_time']+' : '+obj['systolic']+'/'+obj['diastolic'])
            //prescription_list.push(obj['document_date']+','+obj['report_id']);
            //prescription_list.push('item')
          }
        );
        setBPList(arr)                
        }
      })
      .catch(error=>{
        console.log(error)
      });
    },[]);

    const previousBtn=()=>{
        setNewFlag(false);
    };
    const newRecordingBtn=()=>{
        setNewFlag(true);
    };

    BPPlugin.addListener('sembpmstatus', (info) => {
      setBPStatus(JSON.stringify(info));
      console.log('Received background task completion event: ', info);
    });
    return (
        <div>
            <button onClick={previousBtn}>Previous Recordings</button>
            <button onClick={newRecordingBtn}>New Recording</button>
          {!newFlag && <PreviousList bplist={bpList}/>}
          {newFlag && <NewRecording />}
          <p>{bpstatus}</p>
          <BottomTab />
        </div>
      );
    };

const PreviousList=({bplist}) =>{
    return (
        <div>
          <h1>List of Items</h1>
          <ul>
            {bplist.map((item, index) => (
              <p>{item}</p>
            ))}
          </ul>
        </div>
      );
};

const NewRecording=()=>{
    return(
    <div>
       <h1>Start by clicking 'Connect Device'</h1>
        <button onClick={connectUSBDevice}>Connect Device</button>
        <button onClick={recordBP}>Record</button>
        <button onClick={uploadBP(user_id)}>Upload</button>
    </div>
    );
};

const connectUSBDevice=()=>{
    BPPlugin.connectUSB({ value: 'Connect device' }).then(result => {
      //console.log(result.message); // Log the result from the plugin
      //setText(result.message);
    });
};

const recordBP=()=>{
  BPPlugin.recordBP({ value: 'Record BP' }).then(result => {
    //console.log(result.message); // Log the result from the plugin
    //setText(result.message);
  });
};

const uploadBP=(userid)=>{
  console.log(userid)
  BPPlugin.uploadBP({ value: 'Upload BP',user_id:userid}).then(result => {
  });
};



export default BP;